import { HandHelping, Ban, Ruler, Layers } from "lucide-react";

const benefits = [
  {
    icon: HandHelping,
    title: "We Do the Lifting",
    desc: "Leave everything where it is. Our team carries it out.",
  },
  {
    icon: Ban,
    title: "No Bin Sitting Outside",
    desc: "We arrive, load and leave.",
  },
  {
    icon: Ruler,
    title: "No Guessing Bin Size",
    desc: "Show us what you've got and we'll assess the job.",
  },
  {
    icon: Layers,
    title: "From a Few Items to Full Clear-Outs",
    desc: "Only book the removal service you actually need.",
  },
];

const SkipTheSkip = () => (
  <section className="bg-[#f7f7f7] py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-3">
        Skip the Skip.
      </h2>
      <p className="text-center text-[#1a1a1a]/70 mb-12 md:mb-14 max-w-xl mx-auto">
        You shouldn't have to spend your weekend loading rubbish.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {benefits.map((b) => (
          <div
            key={b.title}
            className="group h-full bg-white rounded-xl p-7 border border-[#1a1a1a]/8 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:shadow-lg hover:-translate-y-0.5 hover:border-orange hover:bg-orange-soft transition-all"
          >
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mb-5">
              <b.icon className="w-6 h-6 text-[#1a1a1a] group-hover:text-orange transition-colors" />
            </div>
            <h3 className="text-lg font-bold text-[#1a1a1a] mb-2 leading-snug">{b.title}</h3>
            <p className="text-[#1a1a1a]/70 text-sm leading-relaxed">{b.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SkipTheSkip;
